import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { getOtherProperties } from "../common/Utils";
import { ContentProps } from "./PropsType";

export default function Content(props: ContentProps) {
  const {
    children,
    className,
    prefixCls = "bm-Content",
    preloader,
    pullToRefresh,
    style,
    ...other
  } = props;
  const [data, setData] = useState({
    loading: false,
    scrollTop: 0,
    transitions: false,
    states: "",
  });
  const [offset, setOffset] = useState({
    x: 0,
    y: 0,
  });
  const { states, transitions }: any = data;
  const { y } = offset;
  const styleClass = classNames(
    prefixCls,
    states ? `${prefixCls}-${states}` : "",
    {
      "bm-transitions": transitions,
    },
    className
  );
  const preloaderHeight = useRef(0);
  const startXY = useRef({
    pageX: 0,
    pageY: 0,
  });
  const scrollElem = useRef(null);
  const preloaderRef = useRef(null);
  const preloaderElem = (
    <div ref={preloaderRef}>
      {preloader ? (
        preloader
      ) : (
        <div className={`${prefixCls}-preloader`}>
          <div className={`${prefixCls}-preloader-loading`} />
          <div className={`${prefixCls}-preloader-arrow`} />
        </div>
      )}
    </div>
  );
  const styles = {
    transform: `translate3d(0, ${y}px, 0)`,
    ...style,
  };
  const otherProps = getOtherProperties(other, [
    "height",
    "infiniteScroll",
    "onInfinite",
    "onContentScroll",
    "onPullStart",
    "onPullMove",
    "onPullEnd",
    "onRefresh",
    "width",
  ]);

  const handleTouchStart = (event: any) => {
    if (!pullToRefresh) {
      return;
    }
    if (
      scrollElem.current &&
      (scrollElem.current as HTMLDivElement).scrollTop > 0
    ) {
      return;
    }
    const touch = event.changedTouches[0];
    startXY.current = {
      pageX: touch.pageX,
      pageY: touch.pageY,
    };
    if (props.onPullStart) {
      (props.onPullStart as () => void)();
    }
    document.addEventListener("touchmove", handleTouchMove);
    document.addEventListener("touchend", handleTouchEnd);
  };

  const handleTouchMove = (event: any) => {
    const touch = event.changedTouches[0];
    const diff = touch.pageY - startXY.current.pageY;
    setOffset((prev) => {
      console.log(prev.y, diff);
      return {
        ...offset,
        y: prev.y + diff,
      };
    });
    startXY.current = {
      pageX: touch.pageX,
      pageY: touch.pageY,
    };
    if (props.onPullMove) {
      (props.onPullMove as () => void)();
    }
  };

  const reset = () => {
    setData({
      loading: false,
      transitions: false,
      states: "",
      scrollTop: 0,
    });
    setOffset({
      x: 0,
      y: 0,
    });
  };

  const done = () => {
    reset();
  };

  const handleTouchEnd = () => {
    if (props.onPullEnd) {
      (props.onPullEnd as () => void)();
    }
    if (y < preloaderHeight.current) {
      setData({
        ...data,
        transitions: true,
      });
      setOffset({
        x: 0,
        y: 0,
      });
    } else if (preloaderHeight.current < y) {
      setData({
        ...data,
        loading: true,
        states: "refreshing",
        transitions: true,
      });
      setOffset({
        ...offset,
        y: preloaderHeight.current,
      });
    }
    document.removeEventListener("touchmove", handleTouchMove);
    document.removeEventListener("touchend", handleTouchEnd);
  };

  const handleTransitionEnd = () => {
    if (pullToRefresh && props.onRefresh) {
      (props.onRefresh as (event: any) => void)({
        done,
      });
    }
  };

  const handleScroll = (event: any) => {
    const scroller = event.target;
    const scrollTop = scroller.scrollTop;
    if (pullToRefresh) {
      setData({
        ...data,
        scrollTop,
      });
    }
    if (props.infiniteScroll && scrollElem.current) {
      const scrollHeight =
        scroller.scrollHeight -
        (scrollElem.current as HTMLDivElement).offsetHeight;
      if (scrollHeight <= scrollTop) {
        if (props.onInfinite) {
          (props.onInfinite as (event: any) => void)({
            done,
          });
        }
      }
    }
    if (props.onContentScroll) {
      (props.onContentScroll as (event: any) => void)(event);
    }
  };

  useEffect(() => {
    if (preloaderRef.current) {
      preloaderHeight.current = (
        preloaderRef.current as HTMLDivElement
      ).offsetHeight;
    }
  }, []);

  return (
    <div
      ref={scrollElem}
      className={styleClass}
      style={styles}
      onScroll={handleScroll}
      {...otherProps}
      onTransitionEnd={handleTransitionEnd}
      onTouchStart={handleTouchStart}
    >
      {pullToRefresh ? preloaderElem : null}
      {children}
    </div>
  );
}
